module.exports = __webpack_public_path__ + "static/img/member231228TW.3d27d3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member231228TW.jpg
// module id = nIKT
// module chunks = 1